import React from 'react'
import Location from '../../modules/Location'

const LocationPage = () => {
  return <Location />
}

export default LocationPage
